import { Path } from './Path.js';

export function LikeArray(x, options) {
  options = options || {};
  // Check if x is not an object
  if (!Path.isObject(x)) return false;
  // Number of keys present.
  let num = 0;
  // Largest int key found.
  let maxKey = null;
  // Number of keys that are empty (either because empty or missing).
  let numEmpty = 0;
  // Loop through keys, checking that all are ints, finding the largest in key, summing the number of empty items, and summing the number of keys present.
  for (let key in x) {
    let intKey = parseInt(options.getKey ? options.getKey(x) : key);
    // Not an int, so this is not like an array.
    if (isNaN(intKey)) return false;
    if (intKey > maxKey) maxKey = intKey;
    if (options.isEmpty ? options.isEmpty(x[key]) : x[key] == null) numEmpty++;
    num++;
  }
  // Add the number of missing keys to numEmpty.
  numEmpty += maxKey - num;
  // To be like an array, half of values between 0 and maxKey must not be empty.
  // If numEmpty is greater than half of maxKey, we know this is not like an array.
  if (numEmpty > maxKey / 2) return false;
  return true;
}
